import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { ClinicaMedicaPacienteVipServiceProxy, CreateClinicaMedicaPacienteVipDto, PacienteDto } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';

@Component({
  selector: 'app-tornar-paciente-vip',
  templateUrl: './tornar-paciente-vip.component.html',
  styleUrls: ['./tornar-paciente-vip.component.scss']
})
export class TornarPacienteVipComponent extends AppComponentBase{

  public paciente: PacienteDto;
  public clinicaId: string;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    inject: Injector,
    private readonly _paceinteVipServer: ClinicaMedicaPacienteVipServiceProxy,
    public bsModalRef: BsModalRef
  ) {
    super(inject)
  }

  protected save() {
    abp.ui.setBusy();
    let registro = new CreateClinicaMedicaPacienteVipDto();
    registro.pacienteId = this.paciente.id;
    registro.profissionalResponsavelId = this.appSession.profissionalId;
    registro.clinicaMedicaId = this.clinicaId ?? this.appSession.clinicaId;
    this._paceinteVipServer.createPacienteVip(registro).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.onSave.emit(result);
      this.bsModalRef.hide();
    })
  }

  protected getIdade() : string{
    return moment().diff(this.paciente.dataNascimento, 'years').toString();
  }
}
